import React from 'react';

const Video = React.forwardRef(({ videoSource, videoType }, ref) => {
  return (
    <video
      autoPlay
      muted
      playsInline
      loop
      preload='true'
      ref={ref}
      className='tos-video tos-hide-before-animated'
      tabIndex="-1"
    >
      <source src={videoSource} type={`video/${videoType}`} />
      Your browser does not support the video tag.
    </video>
  );
});

export default Video;

